import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  browserLocalPersistence,
  setPersistence,
} from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD-XfI4ubl9rt6osOX_jYFow6TPziU0Sms",
  authDomain: "legacyroots.ai",
  projectId: "vanshatree",
  storageBucket: "vanshatree.firebasestorage.app",
  messagingSenderId: "981819003040",
  appId: "1:981819003040:web:a7c9906da10e0619c079c5",
  measurementId: "G-KE13TW56MZ",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Use localStorage persistence (works in in-app browsers like WhatsApp)
try { setPersistence(auth, browserLocalPersistence); } catch (e) {}

const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Upload file to Firebase Storage and return download URL
const uploadFile = async (file, path) => {
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
};

export {
  auth,
  storage,
  googleProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  uploadFile,
  ref,
  getDownloadURL,
};
